import {
  Accounts,
  Groups,
  GroupMappedAccounts,
  MappedAccountIds,
  Group,
  Account,
  LocalisedNames,
  CapitalisedLocale,
} from '../../shared-types'

export type FormatRequestDataOptions = {
  accounts: Accounts
  groups: Groups
  groupMappedAccounts: GroupMappedAccounts
  mappedAccountIds: MappedAccountIds
  shouldUseOriginalNames: boolean
  supportedLocales: CapitalisedLocale[]
}
export type BuildRequestItemOptions = {
  account: Account
  group: Group
  id: number
  shouldUseOriginalNames: boolean
  mappedNumber: string
  supportedLocales: CapitalisedLocale[]
}

export const buildRequestItem = ({
  id,
  mappedNumber,
  account,
  group,
  shouldUseOriginalNames,
  supportedLocales,
}: BuildRequestItemOptions): Account => {
  const localisedNameFields = supportedLocales.reduce(
    (acc, locale) => ({
      ...acc,
      [`name${locale}`]: shouldUseOriginalNames
        ? account[`originalName${locale}`]
        : group[`name${locale}`],
    }),
    {} as Record<keyof LocalisedNames, string>
  )
  return {
    id,
    number: mappedNumber,
    accountType: group.type,
    ...localisedNameFields,
  } as Account
}
